import React from 'react';
import { Space } from 'antd';
import styled, { css } from 'styled-components';

interface Props {
  children: React.ReactNode;
  withTitle?: boolean;
  alignItems?: 'center' | 'flex-start' | 'flex-end';
}

const StyledSpace = styled(Space)<{ $withTitle: boolean; $alignItems: string }>`
  justify-content: space-between;
  align-items: ${({ $alignItems }) => $alignItems};
  width: 100%;

  .ant-space-item {
    ${({ $withTitle }) => ($withTitle ? css`
      &:first-child {
        flex-grow: 1;
        flex-shrink: 1;
        min-width: 0;
        display: flex;
      }
      &:last-child {
        flex-grow: 0;
        flex-shrink: 0;
      }
    ` : css`
      &:first-child {
        flex-grow: 1;
        flex-shrink: 1;
        min-width: 0;
        display: flex;
      }
    `)}
  }
`;

const RouteHeaderRow: React.FC<Props> = ({
  children,
  withTitle = false,
  alignItems = 'center',
}) => {
  return (
    <StyledSpace align={alignItems} $withTitle={withTitle} $alignItems={alignItems}>
      {children}
    </StyledSpace>
  );
};

export default RouteHeaderRow;

